// src/store/slices/goalsSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { goals } from "../../types";
// import { setUserAttributes } from "src/analytics";

// Initial state for the auth slice
const initialState: goals.GoalsStateType = {
  goalsData: {
    data: null,
    isLoading: false,
    error: null,
  },
  setGoals: {
    data: null,
    isLoading: false,
    error: null,
  },
};

// Define the goals slice
const goalsSlice = createSlice({
  name: "goals",
  initialState,
  reducers: {
    // get goals
    getGoalsRequest: (
      state: goals.GoalsStateType,
      action: PayloadAction<any>
    ) => {
      state.goalsData.isLoading = true;
      state.goalsData.data = null;
      state.goalsData.error = null;
    },
    getGoalsSuccess: (
      state: goals.GoalsStateType,
      action: PayloadAction<any>
    ) => {
      state.goalsData.isLoading = false;
      state.goalsData.data = action.payload;
      state.goalsData.error = null;
    },
    getGoalsError: (
      state: goals.GoalsStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.goalsData.isLoading = false;
      state.goalsData.data = null;
      state.goalsData.error = error;
    },

    // set goals
    setGoalsRequest: (
      state: goals.GoalsStateType,
      action: PayloadAction<any>
    ) => {
      state.setGoals.isLoading = true;
      state.setGoals.data = null;
      state.setGoals.error = null;
    },
    setGoalsSuccess: (
      state: goals.GoalsStateType,
      action: PayloadAction<any>
    ) => {
      state.setGoals.isLoading = false;
      state.setGoals.data = action.payload;
      state.setGoals.error = null;
    },
    setGoalsError: (
      state: goals.GoalsStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.setGoals.isLoading = false;
      state.setGoals.data = null;
      state.setGoals.error = error;
    },
  },
});

// Export actions and reducer
export const {
  // get goals
  getGoalsRequest,
  getGoalsSuccess,
  getGoalsError,

  // set goals
  setGoalsRequest,
  setGoalsSuccess,
  setGoalsError,
} = goalsSlice.actions;

export default goalsSlice.reducer;
